import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Rückrufe')
    .setRoute('recall_list')
    .setAdditionalRoutes([
        'recall',
    ]);
